<template>
  <div class="bto-sb-footer-combo">
        <span>{{t('W.Unique')}}</span>
        <span class="bto-sb-combomini3">{{t('W.Min3')}}</span>
        <span class="bto-sb-combomini4">{{t('W.Min4')}}</span>
        <span class="bto-sb-combomini5">{{t('W.Min5')}}</span>
      </div>
</template>

<script>
  export default {
    name: 'CombinabilityLegendComponent',
  };
</script>
